import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ShopBanner,
  ShopSettings,
  ShopSettingsRepository
} from '@infrab4a/connect';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomizationComponent } from 'src/app/components/customization/customization.component';

@Component({
  selector: 'app-glam-beauty-carousel',
  templateUrl: './glam-beauty-carousel.component.html',
  styleUrls: ['./glam-beauty-carousel.component.scss']
})
export class GlamBeautyCarouselComponent
  extends CustomizationComponent
  implements OnInit
{
  pageDocument: ShopSettings;
  pageBanners: ShopBanner[];

  constructor(
    override router: Router,
    @Inject('ShopSettingsRepository')
    private shopSettingsRepository: ShopSettingsRepository,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    super(router);

    this.documentId = 'GLAM_BEAUTY';
    this.newCampaignPage = 'configuracoes/glam-beauty/carousels/new';
    this.editCampaignPage = 'configuracoes/glam-beauty/carousels/edit/';
  }

  async ngOnInit(): Promise<any> {
    await this.getDocument();
  }

  override async getDocument(): Promise<void> {
    this.pageDocument = await this.shopSettingsRepository.get({
      id: this.documentId
    });
    this.pageBanners = this.pageDocument.sections;
  }

  override async onReorder(): Promise<void> {
    await this.shopSettingsRepository.update({
      id: this.documentId,
      sections: this.pageBanners
    });
  }

  override async deleteSection(campaign: ShopBanner): Promise<void> {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-primary',
      message: 'Tem certeza que deseja excluir?',
      header: 'Atenção!',
      accept: async () => {
        this.pageBanners = null;
        const index = this.pageDocument.sections?.findIndex(
          (c: any) => c === campaign
        );

        this.pageDocument.sections?.splice(index, 1);

        await this.shopSettingsRepository.update({
          id: this.documentId,
          sections: this.pageDocument.sections
        });

        this.messageService.add({
          severity: 'success',
          summary: 'Campanha excluída',
          detail: 'A campanha agendada foi excluída com sucesso!'
        });

        this.pageBanners = this.pageDocument.sections;
      },
      reject: () => {
        this.pageBanners = this.pageDocument.sections;
      }
    });
  }

  goToNewScreen() {
    this.navigate(this.newCampaignPage);
  }

  goToEditScreen(banner: ShopBanner) {
    const index = this.pageBanners.indexOf(banner);
    this.navigate(`${this.editCampaignPage}${index}`);
  }
}
